export const profiles = [
    {id: 1, name: 'Director de proyectos'},
    {id: 2, name: 'Control de Obras'},
    {id: 3, name: 'Gerente'},
    {id: 4, name: 'Visualizador'},
    {id: 5, name: 'Administrativo'},
    {id: 6, name: 'Administrador de Sistema'}
];

// Rol super-administrador (por sobre Gerente): acceso a todo.
export const ADMIN_SISTEMA = 'Administrador de Sistema';

